import { AbstractControl, ValidationErrors } from '@angular/forms';

/** Exatamente 2 dígitos. Ex.: 11 */
const DDD_REGEX = /^\d{2}$/;

/**
 * Valida o formato do DDD (2 dígitos).
 * Campo vazio é considerado válido — quem cobra o preenchimento é o Validators.required.
 */
export function dddValidator(control: AbstractControl<string>): ValidationErrors | null {
  const ddd = (control.value ?? '').trim();

  if (!ddd) {
    return null;
  }

  return DDD_REGEX.test(ddd) ? null : { ddd: true };
}
